import classnames from 'classnames';
import React from 'react';
import { Message } from '../message';
import { MessageImplementationProps } from '../message/message';

export type InfoMessageProps = MessageImplementationProps & {
  transparent?: boolean;
};

/**
 * This component exposes 3 child components that you can use to build the required markup:
 * `InfoMessageTitle`, `InfoMessageContent` and `InfoMessageActions`.
 *
 * Example:
 * ```tsx
 * const Example = () => (
 *   <InfoMessage>
 *     <InfoMessageTitle>titleTxt</InfoMessageTitle>
 *     <InfoMessageContent><p>contentTxt</p></InfoMessageContent>
 *     <InfoMessageActions><Button /><Button /></InfoMessageActions>
 *   </InfoMessage>
 * )
 * ```
 */
export const InfoMessage = ({ transparent, className, ...props }: InfoMessageProps) => {
  // The transparent version is specific for this component and not handled in <Message>
  const classNames = classnames(className, { 'airtame-info-message--transparent': transparent });
  return <Message className={classNames} cssBlockName="airtame-info-message" {...props} />;
};

InfoMessage.displayName = 'InfoMessage';
